'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _navigationActions = require('../../../reducers/navigationActions');

var _forgottenPasswordActions = require('./forgottenPasswordActions');

var _ForgottenPasswordSuccessModal = require('./ForgottenPasswordSuccessModal');

var _ForgottenPasswordSuccessModal2 = _interopRequireDefault(_ForgottenPasswordSuccessModal);

var _ForgottenPasswordInputModal = require('./ForgottenPasswordInputModal');

var _ForgottenPasswordInputModal2 = _interopRequireDefault(_ForgottenPasswordInputModal);

var _GenericErrorModal = require('../../../components/error/modals/components/GenericErrorModal');

var _GenericErrorModal2 = _interopRequireDefault(_GenericErrorModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Redux connect methods
var mapStateToProps = (0, _reselect.createSelector)(function (state) {
    return state.getIn(['app', 'modal', 'forgottenPassword']);
}, function (forgottenPasswordModalState) {
    return forgottenPasswordModalState.toJS();
});

// Components


// Actions
// Lib


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        onSubmit: function onSubmit(_ref) {
            var email = _ref.email;
            return dispatch((0, _forgottenPasswordActions.passwordResetRequestSubmitted)({ email: email }));
        },
        dispatchNavigateToLogin: function dispatchNavigateToLogin(event) {
            event.preventDefault();
            dispatch((0, _navigationActions.navigateToLogin)());
        }
    };
};

var ForgottenPasswordModal = function ForgottenPasswordModal(props) {
    var dispatchNavigateToLogin = props.dispatchNavigateToLogin,
        resetSent = props.resetSent,
        resetEmail = props.resetEmail,
        isError = props.isError,
        error = props.error;


    if (isError) return _react2.default.createElement(_GenericErrorModal2.default, { error: error, showActions: true });

    return resetSent ? _react2.default.createElement(_ForgottenPasswordSuccessModal2.default, { email: resetEmail, navigateToLogin: dispatchNavigateToLogin }) : _react2.default.createElement(_ForgottenPasswordInputModal2.default, props);
};

ForgottenPasswordModal.propTypes = {
    loginSubmit: _propTypes2.default.func,
    fields: _propTypes2.default.object,
    submitInterceptor: _propTypes2.default.func,
    submitFailed: _propTypes2.default.bool,
    showingErrors: _propTypes2.default.bool,
    submitting: _propTypes2.default.bool,
    dispatchNavigateToLogin: _propTypes2.default.func,
    onChange: _propTypes2.default.func,
    sanitisedErrors: _propTypes2.default.object,
    resetSent: _propTypes2.default.bool,
    isError: _propTypes2.default.bool,
    resetEmail: _propTypes2.default.string,
    error: _propTypes2.default.object
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ForgottenPasswordModal);


//////////////////
// WEBPACK FOOTER
// ./src/client/auth/modals/forgottenPassword/ForgottenPasswordModal.js
// module id = 1678
// module chunks = 0